// Some Android WebViews throw `SecurityError: ... Access is denied for this document.`
// on any localStorage access instead of just returning null (seen in production via
// Sentry issue JAVASCRIPT-REACT-B, uncaught on app mount at AppContext.jsx). Because that
// read sat outside a try/catch, and the axios request interceptor's own read was
// unguarded too, it could fail every subsequent API call and make the app look like it
// never loads. These wrappers give every localStorage call the same graceful fallback
// (null / no-op) that a browser with storage disabled would give for a *supported* API,
// so callers keep working exactly as before whenever storage is actually available.
export const safeLocalStorage = {
  getItem: (key) => {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.error(`safeLocalStorage.getItem('${key}') failed:`, error);
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.error(`safeLocalStorage.setItem('${key}') failed:`, error);
    }
  },
  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`safeLocalStorage.removeItem('${key}') failed:`, error);
    }
  },
};
